// extracted by css-extract-rspack-plugin
export default {"allTitleBox":"allTitleBox-mGxtGb","rowBox":"rowBox-Qh_Dwk","colBox":"colBox-K0HIvX","titleBox":"titleBox-TxB1xA","content":"content-RD5GGm"};